module.exports = __webpack_public_path__ + "static/img/伙伴客户-企鹅杏仁.f25101a6.png";